<div class="requestor-form-wrapper">
  <ng-container *ngFor="let field of config; let i = index">
    <ng-container *ngIf="checkVisibility(field.config, formDetails)">
      <ng-container [ngSwitch]="field.elementKey">
        <div *ngSwitchCase="'RequesterSearch'" class="form-control displayFlexRow">
          <app-search class="requester-search" type="searchAndSelect"
            placeholder="Search Name, Employee ID" (changeCallback)="onRequesterSelect($event)"
            [getCustomOptionValue]="getUserOptionValue" [getCustomOptionLabel]="getUserOptionLabel"
            [fetchAsyncOptions]="requestorSearch">
          </app-search>
        </div>
        <ng-container *ngSwitchCase="'Confirm Button'" >
          <div class="btn-container requestRow" *ngIf="checkVisibility(field.config, formDetails)">
            <button mat-raised-button  color="primary" class="rqstBtn fs-12 font-weight-400" (click)="onConfirmClick()">{{field.config.displayName}}</button>
            <button mat-button class="mr-16 fs-12" *ngIf="!isEditMode" (click)="onClearClick()">Clear</button>
          </div>
        </ng-container>
        <!--   <div *ngSwitchCase="'phonecode'" class="form-control">
          <label class="form-label">
              {{field.config.displayName}}
              <span class="optional" *ngIf="!field.config.mandatory">(optional)</span>
          </label>
          <app-select
            [showClear]="!field.config.mandatory"
            [config]="field.config"
            [type]="formConstants.getElementType(field.config.elementType)"
            [formControl]="getFormControl(field.elementKey)"
            [getCustomOptionValue]="getPhoneCodeValue"
            [getCustomOptionLabel]="getPhoneCodeLabel"
            [options]="phoneCodes">
          </app-select>
        </div>  -->
        <ng-container *ngSwitchDefault>
          <ng-container *ngIf=" field.elementKey === 'paymentType'">
            <div class="form-control mb-16">
              <label class="form-label select-label fs-12 font-weight-400">
                {{field.config.displayName}}
                <span style="color: #B00020; font-size: 16px;" *ngIf="field.config.mandatory">*</span>
                <!-- <span class="optional" *ngIf="!field.config.mandatory">(optional)</span> -->
              </label>
              <div class="form-input">
                <app-field-generator [config]="field.config" [inputControl]="getFormControl(field.elementKey)">
                </app-field-generator>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="field.elementKey === 'Requester'">
            <div class="form-control mb-16">
              <label class="form-label select-label fs-12 font-weight-400">
                {{field.config.displayName}}
              </label>
              <div class="form-input">
                <mis-dropdown [data]="reqTypeMapping" [searchEnabled]="false" [label]="SelectedRequestor" height="40px" width="186px"
                dropdownListHeight="180px" dropdownListWidth="186px" dropdownListPosition="Left" noDataMessage="No Data"
                (onChange)="onRequesterTypeSelect($event)">
                </mis-dropdown>
              </div>
            </div>
          </ng-container>
              <ng-container *ngIf="field.elementKey !== 'Requester' && field.elementKey !== 'paymentType' && field.elementKey !== 'RequesterSearch'">
                <div [hidden]="hideRequesterForm || field.config.isHidden" class="default form-group displayFlexRow mb-16" >
                  <label class="fs-12 font-weight-400" [ngClass]="(field.elementKey === 'gender' || field.elementKey === 'department' || field.elementKey === 'phonecode') ? 'form-select-label' : 'form-label'">
                    {{field.config.displayName}}
                    <!-- {{i}} {{field.config.mandatory}} -->
                    <span style="color: #B00020; font-size: 16px;" *ngIf="field.config.mandatory">*</span>
                  </label>
                  <div class="form-input ml-28">
                  <app-field-generator [config]="field.config" [inputControl]="getFormControl(field.elementKey)" [elementKey]="field.elementKey" [costCenterNames]="costCenterNames"
                   [departmentListName]="departmentListName">
                    </app-field-generator>
                  </div>
                </div>
              </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>
</div>